import { useState } from "react";
import { Card, CardBody, Col, Collapse } from "reactstrap";
import { Btn, P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ButtonWithEvent, CollapesAccordionTitle, LinkWithHref } from "../../../../Constants/Constants";
import { CollapesAccordionSubTitle } from "../../../../Data/UiKits/Accordion";

const CollapesAccordion = () => {
  const [open, setOpen] = useState(false);
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={CollapesAccordionTitle} span={CollapesAccordionSubTitle} />
        <CardBody className="collapse-accordion">
          <P className="common-flex">
            <Btn color="dark" onClick={() => setOpen(!open)}>{LinkWithHref}</Btn>
            <Btn color="dark" onClick={() => setOpen(!open)}>{ButtonWithEvent}</Btn>
          </P>
          <Collapse isOpen={open} className={`btn-dark mt-3`}>
            <Card>
              <CardBody className="mb-0 dark-accordion txt-light bg-dark rounded-3">{"Some placeholder content for the collapse component. This panel is hidden by default but revealed when the user activates the relevant trigger."}</CardBody>
            </Card>
          </Collapse>
        </CardBody>
      </Card>
    </Col>
  );
};
export default CollapesAccordion;
